var _mask, _g, _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _ellipse, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchWithNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 313,
    viewBox: "0 0 301 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 27,
    width: 245,
    height: 219
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.497 28.4254C217.292 39.856 267.618 98.1846 257.567 161.72C249.337 213.737 176.272 200.794 126.712 216.674C91.0406 228.105 51.5193 262.625 27.5632 235.422C0.725765 204.949 20.0455 157.797 42.7557 121.341C71.5139 75.1739 105.67 18.873 156.497 28.4254Z",
    fill: "#FC7292"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.787 28.0738C217.498 39.5425 267.754 98.0657 257.717 161.813C249.498 214.003 176.535 201.017 127.044 216.951C91.4224 228.419 51.9561 263.055 28.0333 235.761C1.23324 205.186 20.5261 157.877 43.2047 121.299C71.9228 74.9783 106.032 18.4894 156.787 28.0738Z",
    fill: "#00C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.884 235.365C159.908 243.444 135.991 232.813 115.948 220.698C97.2608 209.403 86.5797 190.926 76.3685 171.588C62.522 145.367 32.6715 116.715 47.4678 91.0147C62.354 65.1577 102.997 82.2497 131.907 75.1201C157.251 68.8698 178.731 45.061 203.76 52.4709C231.637 60.7242 257.655 84.5919 261.497 113.486C265.138 140.865 236.09 158.974 220.996 182.082C208.468 201.26 203.348 227.474 181.884 235.365Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M168.074 14.9795C184.296 29.3327 208.109 66.0926 173.581 98.3067C130.421 138.574 202.814 192.595 221.881 155.121C240.948 117.647 257.549 93.0351 295.354 102.037",
    stroke: "#1D263A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "14 10"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.8347 32.1732C81.3749 69.9192 0.0706463 87.4536 75.2242 138.686C120.068 175.83 91.5933 225.127 42.083 232.141",
    stroke: "#1D263A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "14 10"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 81.9999,
    width: 109,
    height: 47,
    rx: 8,
    fill: "#FFFEFE",
    stroke: "#1D263A",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 95.9999,
    width: 13,
    height: 18,
    rx: 2,
    fill: "#D7D7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.625 160.5L251.125 160.5C250.86 160.5 250.605 160.395 250.418 160.207C250.23 160.02 250.125 159.765 250.125 159.5L250.125 155C250.125 154.735 250.23 154.48 250.418 154.293C250.605 154.105 250.86 154 251.125 154C251.39 154 251.645 154.105 251.832 154.293C252.02 154.48 252.125 154.735 252.125 155L252.125 158.5L255.625 158.5C255.89 158.5 256.145 158.605 256.332 158.793C256.52 158.98 256.625 159.235 256.625 159.5C256.625 159.765 256.52 160.02 256.332 160.207C256.145 160.395 255.89 160.5 255.625 160.5Z",
    fill: "#1D263A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268 165C267.735 165 267.481 164.895 267.293 164.707C267.106 164.52 267 164.265 267 164C267.001 162.24 266.421 160.528 265.349 159.131C264.278 157.734 262.776 156.73 261.075 156.274C259.375 155.818 257.571 155.937 255.945 156.61C254.319 157.284 252.96 158.476 252.08 160.001C251.948 160.231 251.729 160.398 251.473 160.466C251.216 160.535 250.943 160.498 250.714 160.365C250.484 160.233 250.317 160.014 250.249 159.758C250.18 159.501 250.217 159.229 250.349 158.999C251.45 157.093 253.148 155.604 255.181 154.762C257.214 153.92 259.468 153.772 261.594 154.342C263.719 154.912 265.597 156.168 266.937 157.914C268.276 159.66 269.001 161.799 269 164C269 164.265 268.895 164.52 268.708 164.707C268.52 164.895 268.266 165 268 165ZM266.875 174C266.61 174 266.356 173.895 266.168 173.707C265.981 173.52 265.875 173.265 265.875 173L265.875 169.5L262.375 169.5C262.11 169.5 261.856 169.395 261.668 169.207C261.481 169.02 261.375 168.765 261.375 168.5C261.375 168.235 261.481 167.98 261.668 167.793C261.856 167.605 262.11 167.5 262.375 167.5L266.875 167.5C267.141 167.5 267.395 167.605 267.583 167.793C267.77 167.98 267.875 168.235 267.875 168.5L267.875 173C267.875 173.265 267.77 173.52 267.583 173.707C267.395 173.895 267.141 174 266.875 174Z",
    fill: "#1D263A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259 174C256.349 173.997 253.807 172.942 251.932 171.068C250.058 169.193 249.003 166.651 249 164C249 163.735 249.105 163.48 249.293 163.293C249.48 163.105 249.735 163 250 163C250.265 163 250.52 163.105 250.707 163.293C250.895 163.48 251 163.735 251 164C250.999 165.76 251.58 167.472 252.651 168.869C253.722 170.266 255.225 171.27 256.925 171.726C258.626 172.182 260.429 172.063 262.055 171.39C263.682 170.716 265.04 169.524 265.92 167.999C265.986 167.885 266.073 167.786 266.178 167.706C266.282 167.626 266.401 167.568 266.528 167.534C266.655 167.5 266.787 167.491 266.917 167.509C267.047 167.526 267.173 167.569 267.287 167.634C267.4 167.7 267.5 167.788 267.58 167.892C267.659 167.996 267.718 168.115 267.752 168.242C267.786 168.369 267.794 168.501 267.777 168.632C267.76 168.762 267.717 168.887 267.651 169.001C266.772 170.517 265.51 171.777 263.992 172.654C262.474 173.531 260.753 173.995 259 174Z",
    fill: "#1D263A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 95.9999,
    width: 13,
    height: 18,
    rx: 2,
    fill: "#D7D7D7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 95.9999,
    width: 13,
    height: 18,
    rx: 2,
    fill: "#D7D7D7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 95.9999,
    width: 13,
    height: 18,
    rx: 2,
    fill: "#D7D7D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136 238L67.9998 256.5C66.1665 254.667 64.0998 250.4 70.4998 248C76.8998 245.6 116.833 234.667 136 229.5C138.5 230.667 147.5 234 163.5 238C183.5 243 230 229 235 226C240 223 248 229 235 238C222 247 188.5 256.5 167.5 251C150.7 246.6 139.5 240.5 136 238Z",
    fill: "#ECECEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.745 215.463L122.85 226.441L119.037 215.451L150.932 204.472L154.745 215.463Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.808 224.471L152.77 214.502L149.974 206.443L121.012 216.412L123.808 224.471ZM154.745 215.463L150.932 204.472L119.037 215.451L122.85 226.441L154.745 215.463Z",
    fill: "#1D263A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.489 215.37C138.244 220.428 136.405 225.65 132.382 227.035L68.2805 249.101C64.2576 250.486 59.5739 247.508 57.8193 242.451C56.0646 237.393 57.9035 232.17 61.9264 230.786L126.028 208.72C130.051 207.335 134.734 210.312 136.489 215.37Z",
    fill: "#1D263A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.013 209.212C148.552 190.592 158.42 170.3 177.052 163.887C195.685 157.474 216.027 167.369 222.488 185.988C228.948 204.608 219.081 224.9 200.448 231.313C181.816 237.726 161.474 227.831 155.013 209.212Z",
    fill: "#C2F8FF",
    fillOpacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.856 151.794C147.54 160.507 134.133 188.079 142.911 213.377C151.689 238.675 179.328 252.119 204.644 243.406C229.96 234.693 243.366 207.122 234.588 181.824C225.81 156.525 198.172 143.081 172.856 151.794ZM177.052 163.887C158.419 170.3 148.552 190.592 155.013 209.212C161.473 227.831 181.815 237.726 200.448 231.313C219.08 224.901 228.948 204.608 222.487 185.989C216.026 167.369 195.684 157.474 177.052 163.887Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.364 153.26C148.859 161.694 135.881 188.383 144.378 212.872C152.875 237.36 179.629 250.375 204.135 241.94C228.641 233.506 241.619 206.817 233.122 182.328C224.624 157.84 197.87 144.825 173.364 153.26ZM153.546 209.717C146.804 190.288 157.101 169.113 176.543 162.421C195.986 155.729 217.212 166.055 223.954 185.484C230.695 204.913 220.399 226.087 200.956 232.779C181.514 239.471 160.287 229.145 153.546 209.717ZM142.911 213.377C134.133 188.079 147.54 160.507 172.856 151.794C198.172 143.081 225.81 156.525 234.588 181.824C243.366 207.122 229.96 234.693 204.644 243.406C179.328 252.119 151.689 238.675 142.911 213.377ZM155.013 209.212C148.552 190.592 158.419 170.3 177.052 163.887C195.684 157.474 216.026 167.369 222.487 185.989C228.948 204.608 219.08 224.901 200.448 231.313C181.815 237.726 161.473 227.831 155.013 209.212Z",
    fill: "#1D263A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.057 233.801C195.727 234.074 195.237 234.027 194.964 233.697L154.357 184.7C154.083 184.37 154.129 183.881 154.459 183.609C154.789 183.336 155.279 183.383 155.552 183.713L196.159 232.71C196.433 233.04 196.387 233.528 196.057 233.801ZM214.362 224.421C214.035 224.697 213.545 224.655 213.268 224.327L166.571 169.017C166.294 168.689 166.336 168.2 166.663 167.924C166.991 167.649 167.48 167.691 167.757 168.019L214.455 223.329C214.731 223.657 214.69 224.146 214.362 224.421ZM222.453 212.813C222.128 213.092 221.638 213.055 221.358 212.73L200.568 188.604C200.288 188.279 200.325 187.79 200.65 187.511C200.974 187.232 201.464 187.27 201.744 187.594L222.534 211.72C222.814 212.045 222.778 212.534 222.453 212.813ZM195.317 181.34C194.993 181.619 194.503 181.582 194.222 181.258L188.618 174.77C188.338 174.446 188.373 173.956 188.698 173.677C189.022 173.398 189.512 173.434 189.793 173.759L195.397 180.246C195.677 180.571 195.642 181.06 195.317 181.34ZM184.796 169.16C184.472 169.439 183.981 169.403 183.701 169.078L178.784 163.386C178.504 163.061 178.539 162.572 178.864 162.293C179.188 162.013 179.678 162.05 179.959 162.375L184.876 168.067C185.156 168.391 185.12 168.881 184.796 169.16Z",
    fill: "#1D263A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.417 97.375L102.542 97.375C101.995 97.375 101.568 97.6521 101.283 98.0717L97 104.5L101.283 110.92C101.568 111.34 101.995 111.625 102.542 111.625L114.417 111.625C115.288 111.625 116 110.913 116 110.042L116 98.9583C116 98.0875 115.288 97.375 114.417 97.375ZM112.042 107.342L110.925 108.458L108.083 105.616L105.241 108.458L104.125 107.342L106.967 104.5L104.125 101.658L105.241 100.542L108.083 103.384L110.925 100.542L112.042 101.658L109.2 104.5L112.042 107.342Z",
    fill: "#FC7292"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 23.6338,
    ry: 24.0776,
    transform: "matrix(0.975104 -0.221749 0.163154 0.986601 201.766 45.5406)",
    fill: "#FC7292"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M216.328 53.4681C206.844 46.6021 198.691 43.9163 189 56.7683",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(97 95)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWithNoResult);
export default __webpack_public_path__ + "static/media/search-with-no-result.484c15e5fd8832a0f8323496c2a387d3.svg";
export { ForwardRef as ReactComponent };